import React from "react";

import './Label.css';

const Label = ({ name = '', text }) => {
  if (!text) {
    return null;
  }

  if (name) {
    return (
      <label className='Label' htmlFor={name}>{text}</label>
    )
  }

  return (
    <span className='Label'>{text}</span>
  )
};

export default Label;